
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Item } from '@view/a-pedido-cargar/controlador-pedido';
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';
    import { VListItemSubtitle } from 'vuetify/lib';
    import { OpcionDePrecio } from '@/__env/lib/Articulos/Articulo.lib';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import jQuery from 'jquery';


    @Component( {
        name: "Celda",
        props: {},
        components: {
        }
    } )
    export default class Celda extends Vue
    {
        @Prop() Controlador: ControladorInterfaz;
        @Prop() Item: Item;
        @Prop() Posicion: number;
        public Articulo: Articulo = new Articulo();

        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.Articulo = this.Item.Articulo;
            this.Eventos.push( this.Controlador.EdicionPedido.NuevoItem.onEditarItem.subscribe( ( item, index, event ) =>
            {
                if ( item && item.Articulo && item.Articulo.Id == this.Articulo.Id )
                {
                    this.Articulo = item.Articulo;
                    this.Refrescar();
                }

            } ) );

        }

        async Eliminar()
        {
            if ( await this.$EventBus.Mensajes.SiNo( '¿Eliminar el item actual?', this.Item.Articulo.Id + ' se eliminará' ) )
            {
                this.Controlador.EdicionPedido.NuevoItem.Eliminar( this.Item );
            }

        }

        public CargandoPrecios: boolean = false;
        async SiguientePrecio()
        {
            if ( this.CargandoPrecios )
                return;

            this.CargandoPrecios = true;
            let e = await this.Controlador.EdicionPedido.NuevoItem.SiguientePrecio( this.Posicion );
            if ( e.Mensaje )
                Utiles.Notificaciones.Error( e.Mensaje );
            this.CargandoPrecios = false;
        }


        async AnteriorPrecio()
        {
            if ( this.CargandoPrecios )
                return;

            this.CargandoPrecios = true;
            let e = await this.Controlador.EdicionPedido.NuevoItem.SiguientePrecio( this.Posicion, true );
            if ( e.Mensaje )
                Utiles.Notificaciones.Error( e.Mensaje );
            this.CargandoPrecios = false;
        }

        async Abrir()
        {
            this.Controlador.ArticuloSeleccionado = this.Articulo;
            this.Controlador.Vista.BarraDerecha.Modo = 'articulo-detalles';
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
